/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_Payment_DescriptionInputs */

const en_landing_features_payment_description = /** @type {(inputs: Landing_Features_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe, PayPal, Alipay, WeChat Pay — checkout, subscriptions, webhooks, and order management.`)
};

const zh_landing_features_payment_description = /** @type {(inputs: Landing_Features_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe、PayPal、支付宝、微信支付 — 结账、订阅、Webhook 和订单管理。`)
};

/**
* | output |
* | --- |
* | "Stripe, PayPal, Alipay, WeChat Pay — checkout, subscriptions, webhooks, and order management." |
*
* @param {Landing_Features_Payment_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_payment_description = /** @type {((inputs?: Landing_Features_Payment_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_Payment_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_payment_description(inputs)
	return zh_landing_features_payment_description(inputs)
});
export { landing_features_payment_description as "landing.features.payment.description" }